// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "promoCode-eqqdy";
var _4 = "trigger-3_NQK";
var _5 = "content-1a9GW";
var _6 = "contentWrp-26_Z-";
var _7 = "promoCode_empty-2dycw";
var _8 = "promoCode_notApplied-jad-X";
var _9 = "icon-1Iv5o";
var _a = "promoCode_applied-1zUoK";
var _b = "clearWrapper-2ehZf";
var _c = "closeIcon-1t_0R";
var _d = "clear-1Xj5q";
var _e = "icon_notApplied-1OIeZ";
var _f = "clearIcon-1GlpF";
var _10 = "closeButton-1mB9H";
var _11 = "scrollBody-3V4xW";
export { _1 as "__esModule", _2 as "mobile", _3 as "promoCode", _4 as "trigger", _5 as "content", _6 as "contentWrp", _7 as "promoCode_empty", _8 as "promoCode_notApplied", _9 as "icon", _a as "promoCode_applied", _b as "clearWrapper", _c as "closeIcon", _d as "clear", _e as "icon_notApplied", _f as "clearIcon", _10 as "closeButton", _11 as "scrollBody" }
export default { "__esModule": _1, "mobile": _2, "promoCode": _3, "trigger": _4, "content": _5, "contentWrp": _6, "promoCode_empty": _7, "promoCode_notApplied": _8, "icon": _9, "promoCode_applied": _a, "clearWrapper": _b, "closeIcon": _c, "clear": _d, "icon_notApplied": _e, "clearIcon": _f, "closeButton": _10, "scrollBody": _11 }
